export default __webpack_public_path__ + "images/hand-holding-phone-in-circle.6e09ffc96dc28520f6d6139c05eaf799.png";